<template>
	<div class="content-wrapper">
		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<li class="breadcrumb-item">
					<a href="#">
						<i class="fa fa-home"></i>
						Dashboard
					</a>
				</li>
				<li class="breadcrumb-item active">Monthly Report</li>
			</ol>
		</nav>
		<section class="content">
			<div class="container-fluid">
				<ul class="nav nav-tabs">
					<li class="nav-item">
						<router-link to="/session/monthly" class="nav-link active">
							<h6>Session Wise Report</h6>
						</router-link>
					</li>
					<li class="nav-item">
						<router-link to="/session/monthly/month" class="nav-link">
							<h6>Month Wise Report</h6>
						</router-link>
					</li>
				</ul>
				<div class="row justify-content-md-center">
					<div class="col-sm-12">
						<div class="card">
							<div class="card-header">
								<h3 class="card-title">Monthly Report</h3>
								<div class="card-tools">
									<label>Total no of days : {{ total_days }}</label>
									<label class="pl-4">Total no of working days : {{ total_working_days }}</label>
								</div>
							</div>
							<div class="card-body">
								<div class="row">
									<div class="col-sm-3" v-can="'change_branch'">
										<div class="form-group">
											<label for="from_date">Branch</label>
											<select class="form-control form-control-sm" v-model="meta.branch_id">
												<option value="" disabled>Select Branch</option>
												<option v-for="branch in branches" :key="branch.branch_id"
													:value="branch.branch_id">
													{{ branch.branch_name }}
												</option>
											</select>
										</div>
									</div>
									<div class="col-sm-3">
										<div class="form-group">
											<label for="from_date">Month</label>
											<input type="month" class="form-control form-control-sm"
												v-model="meta.month">
										</div>
									</div>
									<div class="col-sm-3">
										<div class="form-group" style="margin-top: 26px !important;">
											<button class="btn btn-sm btn-primary mr-2" @click="index"><i
													class="fa fa-search mr-1"></i>Search</button>
											<button class="btn btn-sm btn-danger" @click="discard"><i
													class="fa fa-times mr-1"></i>Discard</button>
										</div>
									</div>
								</div>

								<div class="table-responsive">
									<table class="table table-bordered table-striped table-sm">
										<thead>
											<tr>
												<th class="text-center">#</th>
												<th @click="sort('start')">
													Start Date & Time
													<span>
														<i v-if="meta.keyword == 'start' && meta.order_by == 'asc'"
															class="fas fa-sort-up"></i>
														<i v-else-if="meta.keyword == 'start' && meta.order_by == 'desc'"
															class="fas fa-sort-down"></i>
														<i v-else class="fas fa-sort"></i>
													</span>
												</th>
												<th @click="sort('end')">
													End Date & Time
													<span>
														<i v-if="meta.keyword == 'end' && meta.order_by == 'asc'"
															class="fas fa-sort-up"></i>
														<i v-else-if="meta.keyword == 'end' && meta.order_by == 'desc'"
															class="fas fa-sort-down"></i>
														<i v-else class="fas fa-sort"></i>
													</span>
												</th>
												<th @click="sort('total_time')">
													Total Time
													<span>
														<i v-if="meta.keyword == 'total_time' && meta.order_by == 'asc'"
															class="fas fa-sort-up"></i>
														<i v-else-if="meta.keyword == 'total_time' && meta.order_by == 'desc'"
															class="fas fa-sort-down"></i>
														<i v-else class="fas fa-sort"></i>
													</span>
												</th>
												<th class="text-center">
													Tables
												</th>
												<th class="text-center">
													Walkins
												</th>
												<th class="text-center">
													Total BuyIn
												</th>
												<th class="text-center">
													Avg BuyIn
												</th>
												<th class="text-center">
													Rake
												</th>
												<th class="text-center">
													GST
												</th>
												<th>
													Rake %
												</th>
												<th class="text-center">
													Expense
												</th>
												<th class="text-center">
													Expense %
												</th>
												<th class="text-center">Tips</th>
												<th class="text-center">Tips %</th>
												<th class="text-center">Avg Gross Rake / Head</th>
												<th class="text-center">Avg Gross Expense / Head</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(session_log, key) in session_logs" :key="key">
												<td class="text-center">{{ key + 1 }}</td>
												<td>{{ $formatDate(session_log.start, 'india') }}</td>
												<td>{{ $formatDate(session_log.end, 'india') }}</td>
												<td>{{ session_log.total_time }}</td>
												<td class="text-center">{{ session_log.active_tables }}</td>
												<td class="text-center">{{ session_log.walkins }}</td>
												<td class="text-center">{{ $formatCurrency(session_log.buyins) }}</td>
												<td class="text-center">{{ $formatCurrency(session_log.avg_buyins) }}
												</td>
												<td class="text-center">{{ $formatCurrency(session_log.experience_fees)
												}}</td>
												<td class="text-center">{{ $formatCurrency(session_log.gst) }}</td>
												<td class="text-center">{{ session_log.experience_fees_per }}%</td>
												<td class="text-center">{{ $formatCurrency(session_log.expense) }}</td>
												<td class="text-center">{{ session_log.expense_per }}%</td>
												<td class="text-center">{{ $formatCurrency(session_log.tips || 0) }}
												</td>
												<td class="text-center">{{ computeTipsPer(session_log) }}%</td>
												<td class="text-center">{{
													$formatCurrency(computeRakePerHead(session_log)) }}</td>
												<td class="text-center">{{
													$formatCurrency(computeExpensePerHead(session_log)) }}</td>
											</tr>
											<tr>
												<th colspan="3" class="text-center">Total</th>
												<th class="text-center">{{ totalTimeFormatted }}</th>
												<th class="text-center">{{ totalActiveTables }}</th>
												<th class="text-center">{{ totalWalkins }}</th>
												<th class="text-center">{{ $formatCurrency(totalBuyins) }}</th>
												<th class="text-center">{{ $formatCurrency(totalAvgBuyinsPerHead) }}
												</th>
												<th class="text-center">{{ $formatCurrency(totalExperienceFees) }}</th>
												<th class="text-center">{{ $formatCurrency(totalGst) }}</th>
												<th class="text-center">{{ totalExperienceFeesPer }}%</th>
												<th class="text-center">{{ $formatCurrency(totalExpense) }}</th>
												<th class="text-center">{{ totalExpensePer }}%</th>
												<th class="text-center">{{ $formatCurrency(totalTips) }}</th>
												<th class="text-center">{{ totalTipsPer }}%</th>
												<th class="text-center">{{ $formatCurrency(totalRakePerHead) }}</th>
												<th class="text-center">{{ $formatCurrency(totalExpensePerHead) }}</th>
											</tr>
											<tr>
												<th colspan="3" class="text-center">Average</th>
												<th class="text-center">{{ avgTimeFormatted }}</th>
												<th class="text-center">{{ avgActiveTables }}</th>
												<th class="text-center">{{ avgWalkins }}</th>
												<th class="text-center">{{ $formatCurrency(avgBuyins) }}</th>
												<th class="text-center">{{ $formatCurrency(avgBuyinsPerHead) }}</th>
												<th class="text-center">{{ $formatCurrency(avgExperienceFees) }}</th>
												<th class="text-center">{{ $formatCurrency(avgGst) }}</th>
												<th class="text-center">{{ avgExperienceFeesPer }}%</th>
												<th class="text-center">{{ $formatCurrency(avgExpense) }}</th>
												<th class="text-center">{{ avgExpensePer }}%</th>
												<th class="text-center">{{ $formatCurrency(avgTips) }}</th>
												<th class="text-center">{{ avgTipsPer }}%</th>
												<th class="text-center">{{ $formatCurrency(avgRakePerHead) }}</th>
												<th class="text-center">{{ $formatCurrency(avgExpensePerHead) }}</th>
											</tr>
											<tr>
												<th colspan="3" class="text-center">Forecast</th>
												<th class="text-center">{{ forecastTimeFormatted }}</th>
												<th class="text-center">{{ forecastActiveTables }}</th>
												<th class="text-center">{{ forecastWalkins }}</th>
												<th class="text-center">{{ $formatCurrency(forecastBuyins) }}</th>
												<th class="text-center">{{ $formatCurrency(forecastAvgBuyinsPerHead) }}
												</th>
												<th class="text-center">{{ $formatCurrency(forecastExperienceFees) }}
												</th>
												<th class="text-center">{{ $formatCurrency(forecastGst) }}</th>
												<th class="text-center">{{ forecastExperienceFeesPer }}%</th>
												<th class="text-center">{{ $formatCurrency(forecastExpense) }}</th>
												<th class="text-center">{{ forecastExpensePer }}%</th>
												<th class="text-center">{{ $formatCurrency(forecastTips) }}</th>
												<th class="text-center">{{ forecastTipsPer }}%</th>
												<th class="text-center">{{ $formatCurrency(forecastRakePerHead) }}</th>
												<th class="text-center">{{ $formatCurrency(forecastExpensePerHead) }}
												</th>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import moment from "moment";
export default {
	name: "Report.ExperienceReport",
	data() {
		return {
			status: true,
			meta: {
				branch_id: this.$store.getters.user.branch_id,
				month: "",
				order_by: "asc",
				keyword: "start",
			},
			selectedBranch: "",
			session_logs: [],
			total_days: 0,
			total_working_days: 0,
			gst: 0,
			errors: [],
			branches: []
		};
	},
	mounted() {
		let vm = this;
		vm.getBranches();
		vm.discard();
	},

	methods: {
		index() {
			let vm = this;
			let loader = vm.$loading.show();
			vm.$store.dispatch("post", { uri: "getSessionLogsWithMonthlyReport", data: vm.meta })
				.then(function (response) {
					loader.hide();
					vm.session_logs = response.data.session_logs;
					vm.total_days = response.data.total_days;
					vm.total_working_days = response.data.total_working_days;
					vm.total_experience_fees = response.data.total_experience_fees;
					vm.average_experience_fees = response.data.average_experience_fees;
					vm.forecasted_experience_fees = response.data.forecasted_experience_fees;
					vm.total_gst = response.data.total_gst;
					vm.balance_experience_fees = response.data.balance_experience_fees;
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},
		getBranches() {
			let vm = this;
			vm.$store
				.dispatch("post", { uri: "getBranches" })
				.then(function (response) {
					vm.branches = response.data.data;
				})
				.catch(function (error) {
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
		},
		handleBranchChange() {
			this.meta.branch_id = this.selectedBranch ? this.selectedBranch : this.$store.getters.user.branch_id;
			this.meta.page = 1;
		},
		onBranchChange() {
			this.meta.page = 1;
		},
		discard() {
			let vm = this;
			vm.meta.month = moment().format('YYYY-MM');
		},
		sort(field) {
			this.meta.keyword = field;
			this.meta.order_by = this.meta.order_by == 'asc' ? 'desc' : 'asc';
			this.index();
		},
		computeTipsPer(session_log) {
			const tips = session_log.tips || 0;
			const rake = session_log.experience_fees || 0;
			return rake != 0 ? ((tips / rake) * 100).toFixed(2) : 0;
		},
		computeRakePerHead(session_log) {
			const rake = session_log.experience_fees || 0;
			const heads = session_log.walkins || 0;
			return heads != 0 ? (rake / heads).toFixed(2) : 0;
		},
		computeExpensePerHead(session_log) {
			const exp = session_log.expense || 0;
			const heads = session_log.walkins || 0;
			return heads != 0 ? (exp / heads).toFixed(2) : 0;
		}
	},

	computed: {
		totalActiveTables() {
			return this.session_logs.reduce((total, session_log) => {
				return total + session_log.active_tables;
			}, 0);
		},
		totalWalkins() {
			return this.session_logs.reduce((total, session_log) => {
				return total + session_log.walkins;
			}, 0);
		},
		totalBuyins() {
			return this.session_logs.reduce((total, session_log) => {
				return total + session_log.buyins;
			}, 0);
		},
		totalExperienceFees() {
			return this.session_logs.reduce((total, session_log) => {
				return total + session_log.experience_fees;
			}, 0);
		},
		totalExperienceFeesPer() {
			return this.totalBuyins != 0 ? ((this.totalExperienceFees / this.totalBuyins) * 100).toFixed(2) : 0
		},
		totalExpense() {
			return this.session_logs.reduce((total, session_log) => {
				return total + session_log.expense;
			}, 0);
		},
		totalGst() {
			return this.session_logs.reduce((total, session_log) => {
				return total + (session_log.gst || 0);
			}, 0);
		},
		totalTips() {
			return this.session_logs.reduce((total, session_log) => {
				return total + (session_log.tips || 0);
			}, 0);
		},
		totalTipsPer() {
			return this.totalExperienceFees != 0 ? ((this.totalTips / this.totalExperienceFees) * 100).toFixed(2) : 0
		},
		totalExpensePer() {
			return this.totalExperienceFees != 0 ? ((this.totalExpense / this.totalExperienceFees) * 100).toFixed(2) : 0;
		},
		totalAvgGrossRake() {
			return this.totalBuyins != 0 ? ((this.totalExperienceFees / this.totalBuyins) * 100).toFixed(2) : 0
		},
		totalAvgGrossExpense() {
			return this.totalBuyins != 0 ? ((this.totalExpense / this.totalBuyins) * 100).toFixed(2) : 0
		},
		avgActiveTables() {
			return this.total_working_days != 0 ? (this.totalActiveTables / this.total_working_days).toFixed(2) : 0;
		},
		avgWalkins() {
			return this.total_working_days != 0 ? (this.totalWalkins / this.total_working_days).toFixed(2) : 0;
		},
		avgBuyins() {
			return this.total_working_days != 0 ? (this.totalBuyins / this.total_working_days).toFixed(2) : 0;
		},
		avgExperienceFees() {
			return this.total_working_days != 0 ? (this.totalExperienceFees / this.total_working_days).toFixed(2) : 0;
		},
		avgExperienceFeesPer() {
			return this.avgBuyins != 0 ? ((this.avgExperienceFees / this.avgBuyins) * 100).toFixed(2) : 0
		},
		avgExpense() {
			return this.total_working_days != 0 ? (this.totalExpense / this.total_working_days).toFixed(2) : 0;
		},
		avgGst() {
			return this.total_working_days != 0 ? (this.totalGst / this.total_working_days).toFixed(2) : 0;
		},
		avgTips() {
			return this.total_working_days != 0 ? (this.totalTips / this.total_working_days).toFixed(2) : 0;
		},
		avgTipsPer() {
			return this.avgBuyins != 0 ? ((this.avgTips / this.avgBuyins) * 100).toFixed(2) : 0
		},
		avgExpensePer() {
			return this.avgExperienceFees != 0 ? ((this.avgExpense / this.avgExperienceFees) * 100).toFixed(2) : 0;
		},
		avgAvgGrossRake() {
			return this.avgBuyins != 0 ? ((this.avgExperienceFees / this.avgBuyins) * 100).toFixed(2) : 0
		},
		avgAvgGrossExpense() {
			return this.avgBuyins != 0 ? ((this.avgExpense / this.avgBuyins) * 100).toFixed(2) : 0
		},
		totalRakePerHead() {
			return this.totalWalkins != 0 ? (this.totalExperienceFees / this.totalWalkins).toFixed(2) : 0;
		},
		totalExpensePerHead() {
			return this.totalWalkins != 0 ? (this.totalExpense / this.totalWalkins).toFixed(2) : 0;
		},
		avgRakePerHead() {
			return this.avgWalkins != 0 ? (this.avgExperienceFees / this.avgWalkins).toFixed(2) : 0;
		},
		avgExpensePerHead() {
			return this.avgWalkins != 0 ? (this.avgExpense / this.avgWalkins).toFixed(2) : 0;
		},
		forecastActiveTables() {
			return this.total_days != 0 ? (this.avgActiveTables * this.total_days).toFixed(0) : 0;
		},
		forecastWalkins() {
			return this.total_days != 0 ? (this.avgWalkins * this.total_days).toFixed(0) : 0;
		},
		forecastBuyins() {
			return this.total_days != 0 ? (this.avgBuyins * this.total_days).toFixed(2) : 0;
		},
		forecastExperienceFees() {
			return this.total_days != 0 ? (this.avgExperienceFees * this.total_days).toFixed(2) : 0;
		},
		forecastExperienceFeesPer() {
			return this.forecastBuyins != 0 ? ((this.forecastExperienceFees / this.forecastBuyins) * 100).toFixed(2) : 0;
		},
		forecastExpense() {
			return this.total_days != 0 ? (this.avgExpense * this.total_days).toFixed(2) : 0;
		},
		forecastExpensePer() {
			return this.forecastExperienceFees != 0 ? ((this.forecastExpense / this.forecastExperienceFees) * 100).toFixed(2) : 0;
		},
		forecastGst() {
			return this.total_days != 0 ? (this.avgGst * this.total_days).toFixed(2) : 0;
		},
		forecastTips() {
			return this.total_days != 0 ? (this.avgTips * this.total_days).toFixed(2) : 0;
		},
		forecastTipsPer() {
			return this.forecastExperienceFees != 0 ? ((this.forecastTips / this.forecastExperienceFees) * 100).toFixed(2) : 0;
		},
		forecastRakePerHead() {
			return this.forecastWalkins != 0 ? (this.forecastExperienceFees / this.forecastWalkins).toFixed(2) : 0;
		},
		forecastExpensePerHead() {
			return this.forecastWalkins != 0 ? (this.forecastExpense / this.forecastWalkins).toFixed(2) : 0;
		},
		totalAvgBuyinsPerHead() {
			return this.totalWalkins != 0 ? (this.totalBuyins / this.totalWalkins).toFixed(2) : 0;
		},
		avgBuyinsPerHead() {
			return this.avgWalkins != 0 ? (this.avgBuyins / this.avgWalkins).toFixed(2) : 0;
		},
		forecastAvgBuyinsPerHead() {
			return this.forecastWalkins != 0 ? (this.forecastBuyins / this.forecastWalkins).toFixed(2) : 0;
		},
		// Time totals/averages/forecast
		totalTimeMinutes() {
			return this.session_logs.reduce((mins, s) => {
				const start = moment(s.start);
				const end = s.end ? moment(s.end) : moment();
				return mins + end.diff(start, 'minutes');
			}, 0);
		},
		totalTimeFormatted() {
			const mins = this.totalTimeMinutes;
			const h = Math.floor(mins / 60);
			const m = mins % 60;
			return `${h} hr ${m} min`;
		},
		avgTimeMinutes() {
			return this.total_working_days != 0 ? Math.round(this.totalTimeMinutes / this.total_working_days) : 0;
		},
		avgTimeFormatted() {
			const mins = this.avgTimeMinutes;
			const h = Math.floor(mins / 60);
			const m = mins % 60;
			return `${h} hr ${m} min`;
		},
		forecastTimeMinutes() {
			return this.total_days != 0 ? this.avgTimeMinutes * this.total_days : 0;
		},
		forecastTimeFormatted() {
			const mins = this.forecastTimeMinutes;
			const h = Math.floor(mins / 60);
			const m = mins % 60;
			return `${h} hr ${m} min`;
		},
	}
};
</script>
